import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { merchantResidualsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useSetMerchantResidualsStatusMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({
			residualsStatus,
			withholdReason,
			merchantId,
		}: {
			residualsStatus: number | string | null;
			withholdReason?: number;
			merchantId: string;
			onSuccess?: Function;
		}) =>
			merchantResidualsService.setResidualsStatus(merchantId, {
				residualsStatus,
				withholdReason,
			}),
		{
			onMutate() {
				dispatch(uiActions.showSpinnerOverlay());
			},
			onSuccess(_data, { onSuccess }) {
				onSuccess?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
		},
	);
};

export default useSetMerchantResidualsStatusMutation;
